export default __webpack_public_path__ + "static/RootSans-1Thin-827cf5b1d37d90002bedcf57303dd61e.woff";